import { TResponseApi } from "../../vendors/@types/httpApi";
import AbstractService from "../../vendors/services/abstractService";
import { urlApi } from "../shared/apis/api";

export default class DocumentosService extends AbstractService {
  constructor() {
    super(urlApi, "ManterEvento");
  }

  getTipoEvento() {
    return this.api.get(`${this.rota}/TipoEvento`);
  }

  getAnexoProposta(cdContribuicao: any) {
    return this.api.get(
      `${this.rota}/Documentacao/AnexoProposta?CodProposta=${cdContribuicao}`
    );
  }

  getTema(codigoAudienciaPublica: any) {
    return this.api.get(
      `${this.rota}/Documentacao/Tema?codigoAudienciaPublica=${codigoAudienciaPublica}`
    );
  }

  getTipoArquivo() {
    return this.api.get(`${this.rota}/Documentacao/TipoArquivo`);
  }

  reorderPropostaNorma(payload: {
    codigoAnexoPropostaNorma1: number;
    codigoAnexoPropostaNorma2: number;
    ordem1: number;
    ordem2: number;
  }) {
    return this.api.post(
      `${this.rota}/Documentacao/OrdemAnexoProposta`,
      payload
    );
  }

  addTema(payload: { cdAudienciaPublica: number; dsTema: string }) {
    return this.api.post(`${this.rota}/Documentacao/Tema/Create`, payload);
  }

  addArquivo(payload: { dsTipoArquivo: string; stAtivo: boolean }) {
    return this.api.post(`${this.rota}/Documentacao/TipoArquivo/Create`, payload);
  }

  updateTema(payload: {
    cdAudienciaPublica: number;
    dsTema: string;
    cdSeqTema: number;
  }) {
    return this.api.post(`${this.rota}/Documentacao/Tema/Update`, payload);
  }

  updateFile(payload: {
    cdSeqTipoArquivo: number;
    dsTipoArquivo: string;
    stAtivo: boolean;
  }) {
    return this.api.post(`${this.rota}/Documentacao/TipoArquivo/Update`, payload);
  }

  deleteTema(id: number) {
    return this.api.delete(
      `${this.rota}/Documentacao/Tema/Delete/${id}`
    );
  }

  deleteFile(id: number) {
    return this.api.delete(
      `${this.rota}/Documentacao/TipoArquivo/Delete/${id}`
    );
  }
}
